const getters = {
    workspaceList: state => state.list,
    mainWorkSpace: state => state.list.find(item => item.isMain === 1),
}

export default getters
